import { render, staticRenderFns } from "./ModalDetailArea.vue?vue&type=template&id=63b8e447&scoped=true"
import script from "./ModalDetailArea.vue?vue&type=script&lang=js"
export * from "./ModalDetailArea.vue?vue&type=script&lang=js"
import style0 from "./ModalDetailArea.vue?vue&type=style&index=0&id=63b8e447&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b8e447",
  null
  
)

export default component.exports